<div class="modal-header">
    <button type="button" class="btn-close" (click)="close()" aria-label="Close">
        <i class="feather x"></i>
    </button>
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
    <h4>{{ headline }}</h4>
    <p>
        <span class="description-holder description-pre">{{ descriptionPre }}</span>
        <select (change)="set($event.target.value)" class="form-control picker" [(ngModel)]="initialValue">
            <option value="0">0</option>
            <option value="1" selected>1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="26">26</option>
            <option value="27">27</option>
            <option value="28">28</option>
            <option value="29">29</option>
            <option value="30">30</option>
            <option value="31">31</option>
        </select>
        <span class="description-holder description-post">{{ descriptionPost }}</span>
    </p>
</div>
<div class="modal-footer">
    <div class="row">
        <div class="col-md-6 text-left">
            <button class="btn btn-default" aria-label="Cancel" (click)="close()">
                {{ cancelText }}
            </button>
        </div>
        <div class="col-md-6 text-right">
            <button class="btn btn-primary" (click)="confirm()">
                {{ confirmText }}
            </button>
        </div>
    </div>
</div>